import Query from 'library/util/query';
import { jsonToInputParams } from 'library/util/graph';

const updateUserProfessionalCenterColumns = async (
  professional_center_question_ids = []
) => {
  const params = jsonToInputParams({ professional_center_question_ids });
  try {
    const { data } = await Query(`
    mutation {
      update_user_professional_center_question(${params}) {
        success
      }
    }
    `);
    return data?.update_user_professional_center_question?.success;
  } catch (e) {
    console.error(e);
    return false;
  }
};

export default updateUserProfessionalCenterColumns;
